// import "./productStyle.css";
// import { Link } from "react-router-dom";
// import css from "../../catalogMan/catalog.module.css";
// import { useEffect, useMemo, useState } from "react";

// export default function ManuscriptProductComponent({
//   el,
//   setVisitedProducts,
//   visitedProducts,
// }) {
//   // ---------- helpers ----------
//   const safeText = (v, fallback = "—") => {
//     if (v === null || v === undefined) return fallback;
//     const s = String(v).trim();
//     return s ? s : fallback;
//   };

//   const toArray = (v) => {
//     if (Array.isArray(v)) return v.filter((x) => x !== null && x !== undefined);

//     if (typeof v === "string") {
//       const s = v.trim();
//       if (!s) return [];
//       // підтримка "6, 7, 8" або "6 7 8" або "6-8"
//       if (s.includes(","))
//         return s
//           .split(",")
//           .map((x) => x.trim())
//           .filter(Boolean);
//       return [s];
//     }

//     if (v === null || v === undefined) return [];
//     return [v];
//   };

//   const yearGroupArr = useMemo(() => toArray(el?.yearGroup), [el?.yearGroup]);
//   const yearGroupText = useMemo(() => {
//     if (!yearGroupArr.length) return "—";
//     return yearGroupArr
//       .map((x) => String(x).trim())
//       .filter(Boolean)
//       .join(", ");
//   }, [yearGroupArr]);

//   const bookUid = useMemo(() => safeText(el?.uid, ""), [el?.uid]);
//   const bookFoto = useMemo(() => safeText(el?.bookFoto, ""), [el?.bookFoto]);

//   // ---------- visited ----------
//   const handleProductClick = () => {
//     if (!bookUid) return;

//     const list = Array.isArray(visitedProducts) ? visitedProducts : [];
//     if (list.includes(bookUid)) return;

//     const newVisitedProducts = [...list, bookUid];
//     setVisitedProducts?.(newVisitedProducts);
//     localStorage.setItem("visitedProducts", JSON.stringify(newVisitedProducts));
//   };

//   // ---------- liked ----------
//   const [liked, setLiked] = useState(false);

//   useEffect(() => {
//     try {
//       const likedProducts =
//         JSON.parse(localStorage.getItem("likedProducts")) || [];
//       const isLiked = Array.isArray(likedProducts)
//         ? likedProducts.some((p) => p?.uid === bookUid)
//         : false;
//       setLiked(isLiked);
//     } catch {
//       setLiked(false);
//     }
//   }, [bookUid]);

//   const handleLike = () => {
//     try {
//       let likedProducts =
//         JSON.parse(localStorage.getItem("likedProducts")) || [];
//       if (!Array.isArray(likedProducts)) likedProducts = [];

//       if (!liked) {
//         likedProducts.push(el);
//       } else {
//         likedProducts = likedProducts.filter((p) => p?.uid !== bookUid);
//       }

//       localStorage.setItem("likedProducts", JSON.stringify(likedProducts));
//       setLiked((v) => !v);
//     } catch {
//       // якщо localStorage заблокований/битий — просто перемкнемо UI
//       setLiked((v) => !v);
//     }
//   };

//   // ---------- render ----------
//   const toHref = bookUid ? `/manuscript/${bookUid}` : "#";

//   return (
//     <div className="productBigInCatWrap">
//       <div className="productBigPictureImgWrap">
//         {bookFoto ? (
//           <img
//             src={bookFoto}
//             className="productBigPictureImg"
//             alt={safeText(el?.bookName, "Рукопис")}
//             loading="lazy"
//           />
//         ) : (
//           <div
//             className="productBigPictureImg"
//             style={{ display: "grid", placeItems: "center" }}
//           >
//             <span style={{ opacity: 0.6 }}>Немає фото</span>
//           </div>
//         )}
//       </div>

//       <div className="productBigDescription">
//         <div className="autorAndHud">
//           <p className="autorAndHudP">
//             Дітям:{" "}
//             <span className="autorAndHudPSpan">
//               {yearGroupText !== "—" ? `${yearGroupText} років` : "—"}
//             </span>
//           </p>
//         </div>

//         <p className="autorAndHudP">
//           Унікальні читачі:{" "}
//           <span className="autorAndHudPSpan">{safeText(el?.rating, "0")}</span>
//         </p>

//         <h1 className="bookTitleBigProd" onClick={handleProductClick}>
//           <Link className="bookTitleBigProd" to={toHref}>
//             {safeText(el?.bookName)}
//           </Link>
//         </h1>

//         <p className="autorAndHudP">
//           Автор:{" "}
//           <span className="autorAndHudPSpan">{safeText(el?.autorIdea)}</span>
//         </p>

//         <div className="pawerWrapBlock">
//           <p className="power">Сила</p>
//           <p className="powerDescripProdBig">{safeText(el?.bookPower)}</p>
//           <br />
//           <p className="powerDescripProdBig">{safeText(el?.smallDesc)}</p>
//         </div>

//         <div className="ageLanguageWrapBlock">
//           <p className="ageLanguagePBigProd">Вік: {yearGroupText}</p>
//           <p className="ageLanguagePBigProd">
//             Мова: {safeText(el?.bookLanguage)}
//           </p>
//           <p className="ageLanguagePBigProd">Жанр: {safeText(el?.ganr)}</p>
//           <p className="ageLanguagePBigProd">
//             Призначення: {safeText(el?.forWho)}
//           </p>
//         </div>

//         <div
//           style={{
//             display: "flex",
//             gap: 12,
//             alignItems: "center",
//             flexWrap: "wrap",
//           }}
//         >
//           <Link className={css.buttonToManuscript} to={toHref}>
//             <button
//               className={css.buttonToManuscript}
//               onClick={handleProductClick}
//             >
//               Читати
//             </button>
//           </Link>

//           {/* якщо треба лайк — лишив готове */}
//           {/* <button
//             type="button"
//             onClick={handleLike}
//             aria-pressed={liked}
//             title={liked ? "Прибрати з улюблених" : "Додати в улюблені"}
//             style={{
//               border: "1px solid rgba(0,0,0,0.12)",
//               borderRadius: 12,
//               padding: "10px 14px",
//               background: liked ? "rgba(0,0,0,0.06)" : "transparent",
//               cursor: "pointer",
//             }}
//           >
//             {liked ? "♥ Улюблене" : "♡ В улюблене"}
//           </button> */}
//         </div>
//       </div>
//     </div>
//   );
// }

import "./productStyle.css";
import { Link } from "react-router-dom";
import css from "../../catalogMan/catalog.module.css";
import { useEffect, useMemo, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";

export default function ManuscriptProductComponent({
  el,
  setVisitedProducts,
  visitedProducts,
}) {
  // ---------- helpers ----------
  const safeText = (v, fallback = "—") => {
    if (v === null || v === undefined) return fallback;
    const s = String(v).trim();
    return s ? s : fallback;
  };
  const formatWithSlash = (value, fallback = "—") => {
    if (value === null || value === undefined) return fallback;

    if (Array.isArray(value)) {
      const arr = value.map((item) => String(item).trim()).filter(Boolean);

      return arr.length ? arr.join(" / ") : fallback;
    }

    const text = String(value).trim();

    if (!text) return fallback;

    if (text.includes(",")) {
      return text
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
        .join(" / ");
    }

    if (text.includes("/")) {
      return text
        .split("/")
        .map((item) => item.trim())
        .filter(Boolean)
        .join(" / ");
    }

    return text;
  };

  const formatYears = (value) => {
    const formatted = formatWithSlash(value);

    if (formatted === "—") return "—";

    return `${formatted} років`;
  };
  const toArray = (v) => {
    if (Array.isArray(v)) return v.filter((x) => x !== null && x !== undefined);

    if (typeof v === "string") {
      const s = v.trim();
      if (!s) return [];
      // підтримка "6, 7, 8" або "6 7 8" або "6-8"
      if (s.includes(","))
        return s
          .split(",")
          .map((x) => x.trim())
          .filter(Boolean);
      return [s];
    }

    if (v === null || v === undefined) return [];
    return [v];
  };

  const yearGroupArr = useMemo(() => toArray(el?.yearGroup), [el?.yearGroup]);
  const yearGroupText = useMemo(() => {
    if (!yearGroupArr.length) return "—";
    return yearGroupArr
      .map((x) => String(x).trim())
      .filter(Boolean)
      .join(", ");
  }, [yearGroupArr]);

  const bookUid = useMemo(() => safeText(el?.uid, ""), [el?.uid]);
  const bookFoto = useMemo(() => safeText(el?.bookFoto, ""), [el?.bookFoto]);
  const [authorsList, setAuthorsList] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchAuthors = async () => {
      try {
        const authorsSnapshot = await getDocs(collection(db, "author"));

        const authors = authorsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        if (isMounted) {
          setAuthorsList(authors);
        }
      } catch (error) {
        console.error("Помилка при отриманні авторів:", error);
      }
    };

    fetchAuthors();

    return () => {
      isMounted = false;
    };
  }, []);

  const findAuthorByName = (name) => {
    const authorName = String(name || "").trim();

    if (!authorName || authorName === "—") return null;

    const surname = authorName.split(" ")[0]?.toLowerCase();

    if (!surname) return null;

    return authorsList.find((author) =>
      String(author.name || "")
        .toLowerCase()
        .startsWith(surname),
    );
  };

  const renderAuthor = (name) => {
    const safeName = safeText(name);
    const foundAuthor = findAuthorByName(safeName);

    if (foundAuthor?.uid) {
      return (
        <Link className="autorAndHudPSpan" to={`/author/${foundAuthor.uid}`}>
          {safeName}
        </Link>
      );
    }

    return <span className="autorAndHudPSpan">{safeName}</span>;
  };
  // ---------- visited ----------
  const handleProductClick = () => {
    if (!bookUid) return;

    const list = Array.isArray(visitedProducts) ? visitedProducts : [];
    if (list.includes(bookUid)) return;

    const newVisitedProducts = [...list, bookUid];
    setVisitedProducts?.(newVisitedProducts);
    localStorage.setItem("visitedProducts", JSON.stringify(newVisitedProducts));
  };

  // ---------- liked ----------
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    try {
      const likedProducts =
        JSON.parse(localStorage.getItem("likedProducts")) || [];
      const isLiked = Array.isArray(likedProducts)
        ? likedProducts.some((p) => p?.uid === bookUid)
        : false;
      setLiked(isLiked);
    } catch {
      setLiked(false);
    }
  }, [bookUid]);

  const handleLike = () => {
    try {
      let likedProducts =
        JSON.parse(localStorage.getItem("likedProducts")) || [];
      if (!Array.isArray(likedProducts)) likedProducts = [];

      if (!liked) {
        likedProducts.push(el);
      } else {
        likedProducts = likedProducts.filter((p) => p?.uid !== bookUid);
      }

      localStorage.setItem("likedProducts", JSON.stringify(likedProducts));
      setLiked((v) => !v);
    } catch {
      // якщо localStorage заблокований/битий — просто перемкнемо UI
      setLiked((v) => !v);
    }
  };

  // ---------- render ----------
  const toHref = bookUid ? `/manuscript/${bookUid}` : "#";

  return (
    <div className="productBigInCatWrap">
      <div className="productBigPictureImgWrap">
        {bookFoto ? (
          <img
            src={bookFoto}
            className="productBigPictureImg"
            alt={safeText(el?.bookName, "Рукопис")}
            loading="lazy"
          />
        ) : (
          <div
            className="productBigPictureImg"
            style={{ display: "grid", placeItems: "center" }}
          >
            <span style={{ opacity: 0.6 }}>Немає фото</span>
          </div>
        )}
      </div>

      <div className="productBigDescription">
        <div className="autorAndHud">
          <p className="autorAndHudP">
            Дітям:{" "}
            <span className="autorAndHudPSpan">
              {yearGroupText !== "—" ? `${yearGroupText} років` : "—"}
            </span>
          </p>
        </div>

        <p className="autorAndHudP">
          Унікальні читачі:{" "}
          <span className="autorAndHudPSpan">{safeText(el?.rating, "0")}</span>
        </p>

        <h1 className="bookTitleBigProd" onClick={handleProductClick}>
          <Link className="bookTitleBigProd" to={toHref}>
            {safeText(el?.bookName)}
          </Link>
        </h1>

        <p className="autorAndHudP">Автор: {renderAuthor(el?.autorIdea)}</p>

        <div className="pawerWrapBlock">
          <p className="power">Сила</p>
          <p className="powerDescripProdBig">{safeText(el?.bookPower)}</p>
          <br />
          <p className="powerDescripProdBig">{safeText(el?.smallDesc)}</p>
        </div>

        <div className="ageLanguageWrapBlock">
          <p className="ageLanguagePBigProd">
            Вік: {formatYears(el?.yearGroup)}
          </p>

          <p className="ageLanguagePBigProd">
            Мова: {formatWithSlash(el?.bookLanguage)}
          </p>

          <p className="ageLanguagePBigProd">
            Жанр: {formatWithSlash(el?.ganr)}
          </p>

          <p className="ageLanguagePBigProd">
            Призначення: {formatWithSlash(el?.forWho)}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Link className={css.buttonToManuscript} to={toHref}>
            <div
              className={css.buttonToManuscript}
              onClick={handleProductClick}
            >
              Читати
            </div>
          </Link>

          {/* якщо треба лайк — лишив готове */}
          {/* <button
            type="button"
            onClick={handleLike}
            aria-pressed={liked}
            title={liked ? "Прибрати з улюблених" : "Додати в улюблені"}
            style={{
              border: "1px solid rgba(0,0,0,0.12)",
              borderRadius: 12,
              padding: "10px 14px",
              background: liked ? "rgba(0,0,0,0.06)" : "transparent",
              cursor: "pointer",
            }}
          >
            {liked ? "♥ Улюблене" : "♡ В улюблене"}
          </button> */}
        </div>
      </div>
    </div>
  );
}
